import { Button, Drawer, Grid, Hidden, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
  buttonIcon: {
    marginRight: theme.spacing(1),
  },
  negativeAction: {
    color: '#AF4C4C',
  },
  positiveAction: {
    color: '#3F51B5',
  },
  positiveActive: {
    color: '#263238',
  },
}));

function TableEditBar({
  selected,
  className,
  onDelete,
  content,
  showIcon,
  actionClass,
  buttonConfig,
  icon,
  ...rest
}) {
  const classes = useStyles();
  const open = selected.length > 0;

  return (
    <Drawer
      anchor="bottom"
      open={open}
      // eslint-disable-next-line react/jsx-sort-props
      PaperProps={{ elevation: 24 }}
      variant="persistent"
    >
      <div {...rest} className={clsx(classes.root, className)}>
        <Grid alignItems="center" container spacing={2}>
          <Hidden smDown>
            <Grid item md={3}>
              <Typography color="textSecondary" variant="subtitle1">
                {selected.length} selected
              </Typography>
            </Grid>
          </Hidden>
          <Grid item md={6} xs={12}>
            <div className={classes.actions}>
              {!buttonConfig ? (
                <Button onClick={onDelete} className={classes[actionClass]}>
                  {showIcon && (
                    <>
                      {icon === 'close' ? (
                        <CloseIcon className={classes.buttonIcon} />
                      ) : (
                        <DeleteIcon className={classes.buttonIcon} />
                      )}
                    </>
                  )}
                  {content || 'Delete'}
                </Button>
              ) : (
                buttonConfig.map((config, index) => {
                  const { buttonText, buttonIcon, onClick } = config;
                  return (
                    <React.Fragment key={index}>
                      <Button onClick={onClick} className={classes[actionClass]}>
                        {buttonIcon}
                        {buttonText}
                      </Button>
                    </React.Fragment>
                  );
                })
              )}
            </div>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
}

TableEditBar.propTypes = {
  className: PropTypes.string,
  onDelete: PropTypes.func,
  onMarkPaid: PropTypes.func,
  onMarkUnpaid: PropTypes.func,
  selected: PropTypes.array.isRequired,
};

export default TableEditBar;
